import { connect } from 'react-redux';
import { reloadImages } from '../actionCreators';
import ImageReloader from '../components/ImageReloader';
import { getCurrentScreen } from '../selectors/screen';
function mapStateToProps(state) {
    return {
        currentScreenID: getCurrentScreen(state).id,
    };
}
function mergeProps(stateProps, _a) {
    var dispatch = _a.dispatch;
    return {
        reloadImages: function () {
            dispatch(reloadImages(stateProps.currentScreenID));
        },
    };
}
export default connect(mapStateToProps, null, mergeProps)(ImageReloader);
